// LocaleContext (architecture.md §18). Exposes the current locale + a switcher; persists
// the choice locally and drives react-i18next. User locale also lives in the DB (profile).
import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const LocaleContext = createContext(null);
const STORAGE_KEY = 'daycal.locale';

export function LocaleProvider({ children }) {
  const { i18n } = useTranslation();
  const [locale, setLocaleState] = useState(() => localStorage.getItem(STORAGE_KEY) || 'en');

  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [locale, i18n]);

  const setLocale = useCallback((next) => {
    setLocaleState(next);
    localStorage.setItem(STORAGE_KEY, next);
  }, []);

  return <LocaleContext.Provider value={{ locale, setLocale }}>{children}</LocaleContext.Provider>;
}

export const useLocale = () => useContext(LocaleContext);
